import {Button, Select, SelectItem} from "@heroui/react";
import _ from 'lodash';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {useEffect} from 'react';

export default function SegmentSpeakers ({speakers, data, onSelectionChange, ...props}) {
	const queryClient = useQueryClient();
	
	return (
		<>
			<Select
				aria-label="Select Speaker"
				className="w-fit"
				disallowEmptySelection
				classNames={{
					popoverContent: "min-w-72 max-w-xs",
					trigger: "min-h-6 h-7 min-w-40 bg-white max-w-[150px]",
					
				}}
				selectedKeys={[_.toString(data?.speaker?.id)]}
				onSelectionChange={(selected) => {
					const selectedSpeaker = _.find(speakers, item => item.id == selected.currentKey)
					onSelectionChange('speaker.id', selectedSpeaker?.id)
					onSelectionChange('speaker.name', selectedSpeaker?.speaker_name || '')
					//onSelectionChange('speaker.voice_name', selectedSpeaker?.voice_name || '')
				}}
			>
				{speakers?.map((item, index) => (
					<SelectItem
						classNames={{
							base: 'data-[selected=true]:!bg-primary data-[selected=true]:!text-white py-2 px-3',
						}}
						key={item?.id}
						textValue={item.speaker_name}>
						{item.speaker_name}
					</SelectItem>
				))}
			</Select>
		</>
	)
}
